
export const saveItemLocalStorage = (name, data) => {
  localStorage.setItem(name, data);
};

export const getItemLocalStorage = (name) => {
  if (typeof window === 'undefined') {
    return null;
  }
  return localStorage.getItem(name);
};

export const persistLocalStorage = (name, data) => {
  localStorage.setItem(name, JSON.stringify(data));
}

export const getPersistLocalStorage = (name) => {
  if (typeof window === 'undefined') return null;
  try {
    const data = localStorage.getItem(name);
    return data ? JSON.parse(data) : null;
  } catch {
    localStorage.removeItem(name);
    return null;
  }
}